// @ts-nocheck THIS FILE IS GENERATED, DO NOT EDIT!
import * as Types from 'generated/graphql-types';

import { gql } from '@apollo/client';
import { FeatureFlagDetailsFragmentDoc } from '../Feature flags/FeatureFlags.graphql-gen';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { groups?: Array<{ id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> }> };

export type GetGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type GetGroupQuery = { group?: { id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> } };

export type GetUsersOnGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  startIndex?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetUsersOnGroupQuery = { group?: { id?: string, users?: { total?: unknown, items?: Array<{ userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> }> } } };

export type UserListFragment = { userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> };

export type GroupDetailsFragment = { id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> };

export type DeleteGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type DeleteGroupMutation = { deleteGroup?: { id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> } };

export type UpsertGroupMutationVariables = Types.Exact<{
  group: Types.GroupInput;
}>;


export type UpsertGroupMutation = { upsertGroup?: { id?: string, key?: string, displayName?: string, description?: string, usersCount?: unknown, usersCanOptIn?: boolean, featureFlagKeys?: Array<string>, featureFlags?: Array<{ id?: string, key: string, description?: string, displayName?: string, global?: boolean, usersCount?: unknown, disabledMessage?: string, enabled?: boolean, from?: string, propertiesJson?: string, to?: string, version?: number }> } };

export type AddUserToGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  userId: Types.Scalars['String']['input'];
}>;


export type AddUserToGroupMutation = { addUserToGroup?: { userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> } };

export type RemoveUserFromGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  userId: Types.Scalars['String']['input'];
}>;


export type RemoveUserFromGroupMutation = { removeUserFromGroup?: { userId?: string, name?: string, nickname?: string, mobileNumber?: string, emailAddress?: string, birthDate?: string, groupIds?: Array<string> } };

export const UserListFragmentDoc = gql`
    fragment UserList on User {
  userId
  name
  nickname
  mobileNumber
  emailAddress
  birthDate
  groupIds
}
    `;
export const GroupDetailsFragmentDoc = gql`
    fragment GroupDetails on Group {
  id
  key
  displayName
  description
  usersCount
  usersCanOptIn
  featureFlagKeys
  featureFlags {
    ...FeatureFlagDetails
  }
}
    ${FeatureFlagDetailsFragmentDoc}`;
export const GetGroupsDocument = gql`
    query GetGroups {
  groups {
    ...GroupDetails
  }
}
    ${GroupDetailsFragmentDoc}`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGroupsQuery | undefined, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = ApolloReactCommon.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupDocument = gql`
    query GetGroup($groupId: String!) {
  group(groupId: $groupId) {
    ...GroupDetails
  }
}
    ${GroupDetailsFragmentDoc}`;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables> & ({ variables: GetGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
// @ts-ignore
export function useGetGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGroupQuery, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetGroupQuery | undefined, GetGroupQueryVariables>;
export function useGetGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupSuspenseQueryHookResult = ReturnType<typeof useGetGroupSuspenseQuery>;
export type GetGroupQueryResult = ApolloReactCommon.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetUsersOnGroupDocument = gql`
    query GetUsersOnGroup($groupId: String!, $search: String, $startIndex: Int, $count: Int) {
  group(groupId: $groupId) {
    id
    users(search: $search, startIndex: $startIndex, count: $count) {
      items {
        ...UserList
      }
      total
    }
  }
}
    ${UserListFragmentDoc}`;

/**
 * __useGetUsersOnGroupQuery__
 *
 * To run a query within a React component, call `useGetUsersOnGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOnGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOnGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      search: // value for 'search'
 *      startIndex: // value for 'startIndex'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetUsersOnGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables> & ({ variables: GetUsersOnGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>(GetUsersOnGroupDocument, options);
      }
export function useGetUsersOnGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>(GetUsersOnGroupDocument, options);
        }
// @ts-ignore
export function useGetUsersOnGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>;
export function useGetUsersOnGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersOnGroupQuery | undefined, GetUsersOnGroupQueryVariables>;
export function useGetUsersOnGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>(GetUsersOnGroupDocument, options);
        }
export type GetUsersOnGroupQueryHookResult = ReturnType<typeof useGetUsersOnGroupQuery>;
export type GetUsersOnGroupLazyQueryHookResult = ReturnType<typeof useGetUsersOnGroupLazyQuery>;
export type GetUsersOnGroupSuspenseQueryHookResult = ReturnType<typeof useGetUsersOnGroupSuspenseQuery>;
export type GetUsersOnGroupQueryResult = ApolloReactCommon.QueryResult<GetUsersOnGroupQuery, GetUsersOnGroupQueryVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($groupId: String!) {
  deleteGroup(groupId: $groupId) {
    ...GroupDetails
  }
}
    ${GroupDetailsFragmentDoc}`;
export type DeleteGroupMutationFn = ApolloReactCommon.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = ApolloReactCommon.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const UpsertGroupDocument = gql`
    mutation UpsertGroup($group: GroupInput!) {
  upsertGroup(group: $group) {
    ...GroupDetails
  }
}
    ${GroupDetailsFragmentDoc}`;
export type UpsertGroupMutationFn = ApolloReactCommon.MutationFunction<UpsertGroupMutation, UpsertGroupMutationVariables>;

/**
 * __useUpsertGroupMutation__
 *
 * To run a mutation, you first call `useUpsertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGroupMutation, { data, loading, error }] = useUpsertGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpsertGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertGroupMutation, UpsertGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertGroupMutation, UpsertGroupMutationVariables>(UpsertGroupDocument, options);
      }
export type UpsertGroupMutationHookResult = ReturnType<typeof useUpsertGroupMutation>;
export type UpsertGroupMutationResult = ApolloReactCommon.MutationResult<UpsertGroupMutation>;
export type UpsertGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertGroupMutation, UpsertGroupMutationVariables>;
export const AddUserToGroupDocument = gql`
    mutation addUserToGroup($groupId: String!, $userId: String!) {
  addUserToGroup(userId: $userId, groupId: $groupId) {
    ...UserList
  }
}
    ${UserListFragmentDoc}`;
export type AddUserToGroupMutationFn = ApolloReactCommon.MutationFunction<AddUserToGroupMutation, AddUserToGroupMutationVariables>;

/**
 * __useAddUserToGroupMutation__
 *
 * To run a mutation, you first call `useAddUserToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToGroupMutation, { data, loading, error }] = useAddUserToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddUserToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument, options);
      }
export type AddUserToGroupMutationHookResult = ReturnType<typeof useAddUserToGroupMutation>;
export type AddUserToGroupMutationResult = ApolloReactCommon.MutationResult<AddUserToGroupMutation>;
export type AddUserToGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToGroupMutation, AddUserToGroupMutationVariables>;
export const RemoveUserFromGroupDocument = gql`
    mutation removeUserFromGroup($groupId: String!, $userId: String!) {
  removeUserFromGroup(userId: $userId, groupId: $groupId) {
    ...UserList
  }
}
    ${UserListFragmentDoc}`;
export type RemoveUserFromGroupMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;

/**
 * __useRemoveUserFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromGroupMutation, { data, loading, error }] = useRemoveUserFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument, options);
      }
export type RemoveUserFromGroupMutationHookResult = ReturnType<typeof useRemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromGroupMutation>;
export type RemoveUserFromGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>;